export * from './dsl/openapi-builder32';
export * from './model/openapi32';
export { Server, ServerVariable } from './model/server';
export type { IExtensionName, IExtensionType, ISpecificationExtension } from './model/specification-extension';
